<template>
  <div
    class="list_item__container"
    v-bind:class="{ list_item__container_warning: warning }"
    v-bind:style="itemStyle"
  >
    <div class="list_item__content list_item__element">
      <div class="list_item__title" v-bind:style="titleStyle">
        {{ title }}
      </div>
    </div>
    <div class="list_item__action list_item__element">
      <slot name="actionInput"></slot>
      <div class="list_item__action_text">
        <img
          src="/img/livePoint.svg"
          class="list_item__action_live_point"
          v-show="hasLivePoint"
        />
        {{ actionText }}
      </div>
      <img
        src="/img/disclosure-indicator.svg"
        class="list_item__action_disclosure"
        v-show="hasDisclosure"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    title: String,
    actionText: String,
    hasDisclosure: { type: Boolean, default: false },
    hasLivePoint: { type: Boolean, default: false },
    warning: { type: Boolean, default: false },
    itemStyle: {
      type: Object,
      default: function () {
        return {}
      },
    },
    titleStyle: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
}
</script>

<style scoped>
.list_item__container {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: #e8e8e8 solid 1px;
  border-collapse: collapse;
  background-color: #ffffff;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
}

.list_item__container.list_item__container_warning {
  color: #ff003d;
  border: 1px #ff003d solid;
}

.list_item__element {
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 12px;
}

.list_item__content {
  align-self: start;
  padding-top: 0px;
  padding-left: 16px;
}
.list_item__action {
  text-align: right;
  padding-right: 16px;
}
.list_item__action_disclosure {
  color: rgba(0, 0, 0, 0.25);
  font-weight: bold;
  margin-left: 8px;
}
.list_item__action_live_point {
  margin-top: 12px;
  margin-bottom: 12px;
}

/* mypage */
input {
  font-size: 14px;
  color: #262626;
}
select {
  direction: rtl;
  font-size: 14px;
  color: #262626;
}

input,
select {
  text-align: right;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 0;
  outline: none;
  background: none;
  line-height: 1.43;
}
</style>
